import moment from 'moment';
import { getRating } from '@/helpers/statusIncident.js';
import { getIncidentStatus } from '@/helpers/statusIncident.js';
import ReassignUserDialog from '../../elements/ReassignUserDialog';
import { mapState, mapActions } from 'vuex';
import { $EventBus } from '@/main';

export default {
	name: 'TicketItem',
	props: {
		value: Boolean,
		tickets: Array,
		loading: Boolean,
		showActions: {
			type: Boolean,
			default: true,
		},
	},

	data() {
		return {
			reassignUserDialog: false,
			loadingNotifications: {},
			loadingDelete: {},
			deleteDialog: false,
			deleteTarget: null,
			source: 'request-list',
			item: null,
		};
	},

	computed: {
		headers() {
			const baseHeaders = [
				{ text: 'Estado', sortable: true, value: 'status' },
				{ text: 'Ticket', sortable: true, value: 'num_ticket' },
				{ text: 'Asunto', sortable: true, value: 'subject' },
				{ text: 'Clasificación', sortable: true, value: 'subtype.classification.name'},
				// { text: 'Descripción', sortable: true, value: 'description' },
				// { text: 'Tipo de atención', sortable: true, value: 'attention_type' },
				{ text: 'Responsable de atención', sortable: true, value: 'responsible.fullName' },
				{ text: 'Cliente interno', sortable: true, value: 'assigned_user.fullName' },
				{ text: 'Servicio', sortable: true, value: 'service' },
			];

			if (this.showActions) {
				baseHeaders.splice(4, 0, { text: 'Fecha de creación', sortable: true, value: 'created_at' });
				baseHeaders.unshift({ text: 'Acciones', value: 'actions', sortable: false });
			} else {
				baseHeaders.unshift({ text: 'Fecha de eliminación', sortable: true, value: 'deleted_at' });
				baseHeaders.unshift({ text: 'Eliminado por', value: 'deleter', sortable: false });
			}

			return baseHeaders;
		},

		hasShowDetailPermission() {
			return this.$store.getters['auth/hasActivity'](
				'solicitudes',
				'detalleSolicitud',
				'mostrarSolicitud'
			);
		},

		hasDisabledTicketReassign() {
			return this.$store.getters['auth/hasActivity'](
				'solicitudes',
				'listaSolicitudes',
				'reasignarResponsable'
			);
		},

		isSuperAdmin() {
			const companyId = parseInt(localStorage.getItem('company_id'));
			const companies = this.user?.companies || [];
			const activeCompany = companies.find((company) => company.id === companyId);
			if (!activeCompany) return false;
			return (activeCompany.profiles || []).some((profile) => profile.role?.name === 'Super Admin');
		},

		...mapState('auth', ['user']),
	},

	created() {
		//this.getUsersActive();
	},

	methods: {
		...mapActions('ticket', ['sendTicketCloseNotificationMail', 'deleteTicket']),

		getRating,
		getIncidentStatus,
		changeFilter() { },

		async sendNotification(id) {
			if (!id) return;
			this.$set(this.loadingNotifications, id, true);
			try {
				const { ok, error } = await this.sendTicketCloseNotificationMail(id);
				if (ok) {
					$EventBus.$emit(
						'showSnack',
						'success',
						'Notificación enviada correctamente.'
					);
				} else {
					$EventBus.$emit(
						'showSnack',
						'error',
						error || 'Error al enviar la notificación.'
					);
				}
			} catch (err) {
				$EventBus.$emit(
					'showSnack',
					'error',
					'Error inesperado al enviar la notificación.'
				);
			} finally {
				this.$set(this.loadingNotifications, id, false);
			}
		},

		formatDate(dateString) {
			if (!dateString) {
				return '-';
			}
			return moment(dateString).format('YYYY-MM-DD HH:mm');
		},

		reassignUser(item) {
			this.item = Object.assign({}, item);
			this.reassignUserDialog = true;
			this.$nextTick(() => {
				document.activeElement.blur();
			});
		},

		getAllTickets() {
			this.$emit('getTickets');
		},

		confirmDelete(item) {
			this.deleteTarget = item;
			this.deleteDialog = true;
		},

		async executeDelete() {
			if (!this.deleteTarget) return;
			const { id, company_id, num_ticket } = this.deleteTarget;
			this.$set(this.loadingDelete, id, true);
			try {
				const { ok, error } = await this.deleteTicket({ id, company_id });
				if (ok) {
					$EventBus.$emit('showSnack', 'success', `Ticket ${num_ticket} eliminado correctamente.`);
					this.deleteDialog = false;
					this.deleteTarget = null;
					this.getAllTickets();
				} else {
					$EventBus.$emit('showSnack', 'error', error || 'Error al eliminar el ticket.');
				}
			} catch (err) {
				$EventBus.$emit('showSnack', 'error', 'Error inesperado al eliminar el ticket.');
			} finally {
				this.$set(this.loadingDelete, id, false);
			}
		},

		disableButtonReassignResponsible(item) {
			const statusIsValid =
				item.status === 'SOLICITADO' ||
				item.status === 'CONSULTA' ||
				item.status === 'RESUELTO' ||
				item.status === 'EN ATENCION';

			const userIsAuthorized =
				item.subtype.classification.responsible_id.id === this.user.id ||
				item.subtype.classification.area.responsible_id.id === this.user.id ||
				this.hasDisabledTicketReassign;

			const shouldEnableButton = statusIsValid && userIsAuthorized;

			return !shouldEnableButton;
		},
	},

	components: {
		ReassignUserDialog,
	},
};
